<style lang="less" scoped>
@import '@/style/index.less';
.home-analysis-dashboard{
  .home-analysis-dashboard-top{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .home-analysis-dashboard-item{
      width: calc(25% - 12px);
    }
  }
  .home-analysis-dashboard-top-second{
    margin-top: 16px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .home-analysis-dashboard-top-second-item{
      width: calc(50% - 8px);
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .home-icon{
        flex: none;
        margin-top: 10px;
      }
      .home-analysis-dashboard-top-second-item-item{
        .home-analysis-dashboard-top-second-item-item-name{
          font-size: 14px;
          line-height: 22px;
        }
        .home-analysis-dashboard-top-second-item-item-data{
          font-size: 32px;
          line-height: 48px;
        }
      }
    }
  }
}
</style>

<template>
  <div class="home-analysis-dashboard">
    <div class="home-analysis-dashboard-top">
      <HomeAnalysisDashboardItem :name="'M0'" :num="top.data.M0" :rate="top.data.M0Rate" :rgb="'140, 84, 255'" />
      <HomeAnalysisDashboardItem :name="'M1'" :num="top.data.M1" :rate="top.data.M1Rate" :rgb="'0, 193, 212'" />
      <HomeAnalysisDashboardItem :name="'M2'" :num="top.data.M2" :rate="top.data.M2Rate" :rgb="'51, 172, 46'" />
      <HomeAnalysisDashboardItem :name="'M3+'" :num="top.data['M3+']" :rate="top.data['M3+Rate']" :rgb="'255, 72, 89'" />
    </div>
    <div class="home-analysis-dashboard-top home-analysis-dashboard-top-second">
      <div class="home-analysis-dashboard-top-second-item home-view-box" :style="{ background: 'linear-gradient( 90deg, #E0EAFE 0%, rgba(224,234,254,0) 100%), #F5F7FA' }">
        <HomeIcon :name="'price'" :rgb="'33, 126, 255'" />
        <div class="home-analysis-dashboard-top-second-item-item">
          <div class="home-analysis-dashboard-top-second-item-item-name local-main-color-secondary-text">今日回款</div>
          <div class="home-analysis-dashboard-top-second-item-item-data" :style="{ color: 'rgba(33, 126, 255,1)' }">
            <NumberChange :data="second.todayPaymentCollection" :decimal="2" />
          </div>
        </div>
        <div class="home-analysis-dashboard-top-second-item-item">
          <div class="home-analysis-dashboard-top-second-item-item-name local-main-color-secondary-text">电催回款</div>
          <div class="home-analysis-dashboard-top-second-item-item-data">
            <NumberChange :data="second.paymentCollection1" :decimal="2" />
          </div>
        </div>
        <div class="home-analysis-dashboard-top-second-item-item">
          <div class="home-analysis-dashboard-top-second-item-item-name local-main-color-secondary-text">上门回款</div>
          <div class="home-analysis-dashboard-top-second-item-item-data">
            <NumberChange :data="second.paymentCollection2" :decimal="2" />
          </div>
        </div>
        <div class="home-analysis-dashboard-top-second-item-item">
          <div class="home-analysis-dashboard-top-second-item-item-name local-main-color-secondary-text">赎回回款</div>
          <div class="home-analysis-dashboard-top-second-item-item-data">
            <NumberChange :data="second.paymentCollectionRedemption" :decimal="2" />
          </div>
        </div>
      </div>
      <div class="home-analysis-dashboard-top-second-item home-view-box" :style="{ background: 'linear-gradient( 90deg, #FFF0F0 0%, rgba(255,240,240,0.01) 100%), #F5F7FA' }">
        <HomeIcon :name="'wave'" :rgb="'255, 0, 0'" />
        <div class="home-analysis-dashboard-top-second-item-item">
          <div class="home-analysis-dashboard-top-second-item-item-name local-main-color-secondary-text">逾期总台数</div>
          <div class="home-analysis-dashboard-top-second-item-item-data" :style="{ color: 'rgba(255, 0, 0,1)' }">
            <NumberChange :data="second.overVehicleCount" />
          </div>
        </div>
        <div class="home-analysis-dashboard-top-second-item-item">
          <div class="home-analysis-dashboard-top-second-item-item-name local-main-color-secondary-text">已收车</div>
          <div class="home-analysis-dashboard-top-second-item-item-data">
            <NumberChange :data="second.keepCount" />
          </div>
        </div>
        <div class="home-analysis-dashboard-top-second-item-item">
          <div class="home-analysis-dashboard-top-second-item-item-name local-main-color-secondary-text">已赎回</div>
          <div class="home-analysis-dashboard-top-second-item-item-data">
            <NumberChange :data="second.handleCount" />
          </div>
        </div>
        <div class="home-analysis-dashboard-top-second-item-item">
          <div class="home-analysis-dashboard-top-second-item-item-name local-main-color-secondary-text">已处置</div>
          <div class="home-analysis-dashboard-top-second-item-item-data">
            <NumberChange :data="second.redemptionCount" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import NumberChange from '@/components/data/NumberChange.vue'
import analysisApi from '@/pages/index/api/analysis'
import { overdueLevel } from '@/pages/index/select/overdue'
import HomeAnalysisDashboardItem from './HomeAnalysisDashboardItem.vue'
import HomeIcon from './HomeIcon.vue'

const overdueLevelList = overdueLevel.getList()

export default defineComponent({
  name: 'HomeAnalysis',
  components: {
    HomeAnalysisDashboardItem,
    HomeIcon,
    NumberChange
  },
  data() {
    const top: Record<string, number> = {}
    overdueLevelList.forEach(item => {
      if (item.value !== '正常') {
        top[item.value] = 0
        top[item.value + 'Rate'] = 0
      }
    })
    return {
      top: {
        data: top
      },
      second: {
        todayPaymentCollection: 0,
        paymentCollection1: 0,
        paymentCollection2: 0,
        paymentCollectionRedemption: 0,
        overVehicleCount: 0,
        keepCount: 0,
        handleCount: 0,
        redemptionCount: 0
      }
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      analysisApi.homeTop.require().then(res => {
        this.top.data.M0 = res.data.data.overCount.M0 || 0
        this.top.data.M1 = res.data.data.overCount.M1 || 0
        this.top.data.M2 = res.data.data.overCount.M2 || 0
        this.top.data['M3+'] = res.data.data.overCount['M3+'] || 0
        this.top.data.M0Rate = res.data.data.overCount.M0Rate || 0
        this.top.data.M1Rate = res.data.data.overCount.M1Rate || 0
        this.top.data.M2Rate = res.data.data.overCount.M2Rate || 0
        this.top.data['M3+Rate'] = res.data.data.overCount['M3+Rate'] || 0
        this.second = res.data.data.paymentCollectionVehicleCount
      })
    }
  }
})
</script>
